import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'app-branding',
  standalone: true,
  imports: [NgIf],
  template: `
    <div class="branding" style="background: #f5f5f9; border-bottom: 4px solid #657fbf;">
      <div style="display:flex;" *ngIf="options.theme === 'light'">
        <img style="width: 170px; margin: auto !important;" src="assets/images/logos/clu-dark-logo-icon.svg" class="align-middle m-2" alt="logo" />
      </div>
      <div style="display:flex;" *ngIf="options.theme === 'dark'">
        <img style="width: 170px; margin: auto !important;" src="assets/images/logos/clu-light-logo.svg" class="align-middle m-2" alt="logo" />
      </div>
    </div>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();

  constructor(private settings: CoreService) {}
}
